import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { PageChrome } from "./PageChrome";
import { useAppActions, useAppState } from "@/app/AppContext";
export const ExceptionPage = () => {
    const navigate = useNavigate();
    const { exception, history } = useAppState();
    const { clearException } = useAppActions();
    const goHome = () => {
        clearException();
        navigate("/home");
    };
    const goBackToGame = () => {
        clearException();
        navigate(history.present ? "/game" : "/home");
    };
    return (_jsx(PageChrome, { background: "board", children: _jsxs("section", { className: "panel strong setup-card stack", style: { width: "min(760px, 100%)", margin: "0 auto" }, children: [_jsx("h1", { className: "headline", children: "Case Interrupted" }), _jsx("p", { className: "error-copy", children: exception?.message ?? "This case hit an unexpected contradiction." }), _jsx("p", { className: "subtle", children: "Review the last move, use undo if needed, or return to the game and fix the data using manual edit." }), _jsxs("div", { className: "button-row", children: [_jsx("button", { className: "button primary", onClick: goBackToGame, children: "Return to Case" }), _jsx("button", { className: "ghost-button", onClick: goHome, children: "Home" })] })] }) }));
};
